import React from 'react';
import { ContainerQ } from './style.css';


const Quote = (props) => {
    return (
        <ContainerQ
            data-sal="slide-up"
            data-sal-delay="2000"
            data-sal-easing="ease"
        >
            <p><strong>{props.name}: </strong>“{props.cita}”.</p>
        </ContainerQ>
    );
}

export default Quote;